export default function keys(object) {
  return Object.keys(object)
}
